import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
});

export const getMembers = async (groupName) => {
  const response = await api.get('/api/members', { params: { group_name: groupName } });
  return response.data;
};

export const createMember = async (name, groupName) => {
  const formData = new FormData();
  formData.append('name', name);
  formData.append('group_name', groupName);
  const response = await api.post('/api/members', formData);
  return response.data;
};

export const deleteMember = async (memberId) => {
  const response = await api.delete(`/api/members/${memberId}`);
  return response.data;
};

export const uploadReceipt = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/api/receipts/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadMissingReceipt = async (itemsFile, bankStatementFile) => {
  const formData = new FormData();
  formData.append('items_image', itemsFile);
  formData.append('bank_statement_image', bankStatementFile);
  const response = await api.post('/api/receipts/upload-missing', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const confirmReceipt = async (data) => {
  const formData = new FormData();
  formData.append('temp_path', data.temp_path);
  formData.append('member_id', data.member_id);
  formData.append('amount', data.amount);
  formData.append('category', data.category);
  if (data.store) formData.append('store', data.store);
  if (data.remarks) formData.append('remarks', data.remarks);
  if (data.event_id) formData.append('event_id', data.event_id);
  formData.append('date', data.date);
  if (data.bank_statement_temp_path) {
    formData.append('bank_statement_temp_path', data.bank_statement_temp_path);
  }
  if (data.receipt_type) formData.append('receipt_type', data.receipt_type);
  formData.append('group_name', data.group_name || 'Dolfijnen');

  const response = await api.post('/api/receipts/confirm', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getStores = async (groupName) => {
  const response = await api.get('/api/stores', { params: { group_name: groupName } });
  return response.data;
};

export const getReceipts = async (filters = {}) => {
  const response = await api.get('/api/receipts', { params: filters });
  return response.data;
};

export const deleteReceipt = async (receiptId) => {
  const response = await api.delete(`/api/receipts/${receiptId}`);
  return response.data;
};

export const updateReceipt = async (receiptId, fields) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v === undefined) return;
    formData.append(k, v === null ? '' : v);
  });
  const response = await api.patch(`/api/receipts/${receiptId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getEvents = async (groupName) => {
  const response = await api.get('/api/events', { params: { group_name: groupName } });
  return response.data;
};

export const getReceiptImageUrl = (receiptId) => {
  return `${API_URL}/api/receipts/${receiptId}/image`;
};

export const getBankStatementImageUrl = (receiptId) => {
  return `${API_URL}/api/receipts/${receiptId}/bank-statement-image`;
};

export const exportQuarterly = async (groupName) => {
  const formData = new FormData();
  formData.append('group_name', groupName || 'Dolfijnen');

  const response = await api.post('/api/export', formData, {
    responseType: 'blob',
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let filename = 'declaraties_export.zip';
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^";\s]+)"?/);
    if (match) filename = match[1];
  }

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return response.data;
};

export const exportEvent = async (eventId, password) => {
  const formData = new FormData();
  formData.append('password', password);
  const response = await api.post(`/api/export/event/${eventId}`, formData, { responseType: 'blob' });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let filename = 'event_export.zip';
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^";\s]+)"?/);
    if (match) filename = match[1];
  }

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return response.data;
};

export const getStatistics = async (groupName, eventId = null) => {
  const params = { group_name: groupName };
  if (eventId != null) params.event_id = eventId;
  const response = await api.get('/api/stats', { params });
  return response.data;
};

export const getGroupSettings = async (groupName) => {
  const response = await api.get(`/api/settings/${groupName}`);
  return response.data;
};

export const updateGroupSettings = async (groupName, password, naam, iban) => {
  const formData = new FormData();
  formData.append('password', password);
  formData.append('naam_rekeninghouder', naam);
  formData.append('iban_rekeningnummer', iban);
  const response = await api.put(`/api/settings/${groupName}`, formData);
  return response.data;
};

export const revertExport = async (receiptId) => {
  const response = await api.patch(`/api/receipts/${receiptId}/revert-export`);
  return response.data;
};

export default api;
